export const getFundsPrimary = (state) => state.funds.primary.data;
export const getFundsManager = (state) => state.funds.market.data;

export const getFundsCurrentTab = (state) => state.funds.currentTab;

export const areFundsPrimaryLoading = (state) => state.funds.primary.isLoading;
export const areFundsManagerLoading = (state) => state.funds.market.isLoading;

export const getSelectedFundsManagerTitle = (state) =>
  state.funds.market.selectedTitle;

export const getFundsWebAreas = (state) => state.funds.webAreas;
